import { createContext, useContext, type ComponentType } from 'react'

export type PageTitleIcon = ComponentType<{ className?: string }>

export type PageTitle = {
  title: string
  subtitle?: string
  accentWord?: string
  icon?: PageTitleIcon
}

export type PageTitleContextValue = {
  pageTitle: PageTitle | null
  setPageTitle: (
    pageTitle: PageTitle | null | ((current: PageTitle | null) => PageTitle | null),
  ) => void
}

export const PageTitleContext = createContext<PageTitleContextValue | null>(null)

export function usePageTitleContext(): PageTitleContextValue {
  const value = useContext(PageTitleContext)
  if (value === null) {
    throw new Error('usePageTitleContext must be used within <PageTitleProvider>')
  }
  return value
}
